import React, { useState, useEffect } from "react";
import { MenusItem } from "./Common";
import styles from "./Menus.module.css";

interface MenusProps {
    options: MenusItem[];
}

const Menus = (props: MenusProps) => {
    return (
        <div className={styles.container}>
            {props.options.map((item: MenusItem, index: number) => {
                return (
                    <div className={styles.item} key={`menuItem_${index}`} onClick={item.onClickItem}>
                        {item.title}
                    </div>
                );
            })}
        </div>
    );
};

export default Menus;
